var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      ref: "countdown-timer-modal",
      staticClass: "countdown-timer-modal",
      attrs: {
        id: "countdown-timer-modal",
        title: "Add a Countdown Timer",
        "class-name": "block-modal fade",
        "close-button": false,
        backdrop: false
      }
    },
    [
      _c(
        "div",
        {
          key: _vm.resetKey,
          staticClass:
            "d-flex mb-3 d-flex flex-row mb-3 gap-15px countdown-time-picker"
        },
        [
          _c(
            "div",
            { staticClass: "w-50" },
            [
              _c("AppFlatPickr", {
                ref: "calendar",
                attrs: {
                  custom_class: "form-control",
                  placeholder: "End Date",
                  min_date: _vm.minDateStart
                },
                on: { onDateSelect: _vm.onDateTimeSelected },
                model: {
                  value: _vm.endDate,
                  callback: function($$v) {
                    _vm.endDate = $$v
                  },
                  expression: "endDate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-50" }, [
            _c(
              "div",
              { staticClass: "datetime-dropdown time" },
              [
                _c("AppDropdown", {
                  staticClass: "form-control py-0",
                  attrs: {
                    placeholder: "End Time",
                    options: _vm.startTimeOptions,
                    searchable: false,
                    label: "name",
                    reduce: "value",
                    rightAlign: false,
                    disabled: _vm.startTimeOptions.length < 1
                  },
                  on: { select: _vm.onDateTimeSelected },
                  model: {
                    value: _vm.endTimeValue,
                    callback: function($$v) {
                      _vm.endTimeValue = $$v
                    },
                    expression: "endTimeValue"
                  }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-column gap v-gap mt-3 pt-1 col-sm" },
        [
          _c(
            "AppButton",
            {
              attrs: { name: "cta-button-modal-countdown-timer-modal" },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v("Add Countdown Timer")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }